module.exports = __webpack_public_path__ + "images/psp/College/unit-5x10.svg";